import styled from "styled-components";
import { ImageWrapper } from "@/lib/styles";

export const Wrapper = styled(ImageWrapper)<{
  $isVertical?: boolean;
}>`
  width: ${({ $isVertical }) => ($isVertical ? "80%" : "100%")};
  padding-bottom: ${({ $isVertical }) =>
    $isVertical ? "calc(4 / 3 * 80%)" : "calc(3 / 4 * 100%)"};
  &:not(:last-child) {
    margin-bottom: 1.5rem;
  }

  opacity: 0;
  .lines {
    opacity: 0;
    transform: translateY(100px);
  }

  ${({ theme }) => theme.mediaQueries.laptop} {
    width: 100%;
    padding-bottom: ${({ $isVertical }) =>
      $isVertical ? "calc(4 / 3 * 100%)" : "calc(3 / 4 * 100%)"};
  }
`;
